import { render, staticRenderFns } from "./AddCurrency.vue?vue&type=template&id=f349c0f4&scoped=true&"
import script from "./AddCurrency.vue?vue&type=script&lang=js&"
export * from "./AddCurrency.vue?vue&type=script&lang=js&"
import style0 from "./AddCurrency.vue?vue&type=style&index=0&id=f349c0f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f349c0f4",
  null
  
)

export default component.exports